import {CreateOperationalEntityData} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResultNode} from "../view-model";

export const toCreateResultNode = (
  result: CreateOperationalEntityData
): CreateResultNode => ({
  caId: result.sources[0].sourceId,
  oeId: result.id,
  dbaName: result.dbaName,
  tenantId: "",
  status: result.status,
  message: result.message,
  children: result.children ? result.children.map(toCreateResultNode) : []
});
